<template>
  <form-step stepName="Dates"
    :checked="checked"
    :validated="validated"
    :declined="declined"
    :checkLoading="checkLoading"
    :onSubmit="onSubmit"
    @reset="$emit('reset')"
    @check="$emit('check', true)"
    @edit="$emit('check', false)"
    @nextStep="$emit('next')">
    <template #title>When are the invoice issue and due dates?</template>
    <template #form>
      <date-range id="invoice-dates"
        v-model="dates" value-format="yyyy-MM-dd"
        start-placeholder="Issue date" end-placeholder="Due date" />
    </template>

    <template #billboard>
    <div v-if="!declined">
      <!-- alert success  -->
      <div class="row justify-content-center">
        <h1 class=""><icon icon="check-circle" class="text-success"/></h1>
        <h2 class="mb-4 mx-5">Awesome! We can cover those dates</h2>
      </div>
      <!-- explanatory cards -->
      <div class="card-deck ">
      <!-- first card -->
        <help-card :content="cards.passOnTime"/>
        <div class="w-100 d-none d-sm-block d-md-none mb-4"><!-- wrap every 2 on sm--></div>
        <help-card :content="cards.weCollectPayments"/>
      </div>
    </div>
    <div v-else>
      <error-display title="Unfortunately we cannot accept your request." :body="checked.rejection_reason.detail"></error-display>
    </div>
    </template>
  </form-step>
</template>

<script>
import FormStep from '@/components/FormStep'
import DateRange from '@/components/DateRange'
import HelpCard from '@/components/HelpCard'
import protectCards from '@/data/protectCards'
import ErrorDisplay from '@/components/ErrorDisplay'

export default {
  name: 'dates',
  components: {
    FormStep,
    DateRange,
    HelpCard,
    ErrorDisplay
  },
  props: {
    checked: Object,
    validated: Boolean,
    checkLoading: Boolean,
    onSubmit: Function,
    value: {}
  },
  computed: {
    issueDate: {
      get: function () { return this.value ? this.value[0] : null },
      set: function (value) { this.$emit('input', [value, this.dueDate]) }
    },
    dueDate: {
      get: function () { return this.value ? this.value[1] : null },
      set: function (value) { this.$emit('input', [this.issueDate, value]) }
    },
    dates: {
      get: function () { return this.value || null },
      set: function (values) { this.$emit('input', values) }
    },
    declined: function () { return this.checked ? this.checked.status === 'rejected' : false }
  },
  data: function () {
    return {
      cards: protectCards
    }
  }
}
</script>
